<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5 class="pull-left">
                Payer Information
            </h5>

            <button type="button" class="btn btn-black btn-sm pull-right" @click="visible = !visible" style="margin-top: 4px">
                <i class="fa" :class="visible ? 'fa-minus' : 'fa-plus'"></i> {{ visible ? 'Hide' : 'Show' }}
            </button>

            <div class="clearfix"></div>
        </div>

        <div v-if="visible" class="panel-body form-horizontal">
            <text-form-group
                    v-model="orderConfirmation.payer_name"
                    name="payer_name"
                    label="Payer Name"
                    help-text="The name of the payer of the order confirmation."
                    :error="getError('payer_name')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.payer_address"
                    name="payer_address"
                    label="Payer Address"
                    help-text="The address of the payer of the order confirmation."
                    :error="getError('payer_address')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.payer_zip_code"
                    name="payer_zip_code"
                    label="Payer Zip Code"
                    help-text="The zip code of the payer of the order confirmation."
                    :error="getError('payer_zip_code')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.payer_city"
                    name="payer_city"
                    label="Payer City"
                    help-text="The city of the payer of the order confirmation."
                    :error="getError('payer_city')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.payer_country"
                    name="payer_country"
                    label="Payer Country"
                    help-text="The country of the payer of the order confirmation."
                    :error="getError('payer_country')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.payer_cvr"
                    name="payer_cvr"
                    label="Payer CVR"
                    help-text="The CVR of the payer of the order confirmation."
                    :error="getError('payer_cvr')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.payer_contact"
                    name="payer_contact"
                    label="Payer Contact"
                    help-text="The name of the contact in the payer company."
                    :error="getError('payer_contact')"
            ></text-form-group>
        </div>
    </div>
</template>

<script>
    import Errors from '@/mixins/Errors'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {TextFormGroup},

        model: {
            prop: 'orderConfirmation',
            event: 'order-confirmation-updated'
        },

        mixins: [Errors],

        props: ['orderConfirmation'],

        data() {
            return {
                visible: false
            }
        },

        methods: {
            update(key, value) {
                this.$emit('order-confirmation-updated', {...this.orderConfirmation, [key]: value})
            }
        }
    }
</script>
